var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInterfaceActionsLinkBreak = function SvgInterfaceActionsLinkBreak(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#interface_actions_linkBreak_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 4a5 5 0 0 0 0 10h4v-2H6a3 3 0 1 1 0-6h4V4H6Zm8 0v2h4a3 3 0 1 1 0 6h-4v2h4a5 5 0 0 0 0-10h-4ZM7 8v2h10V8H7Zm10.414 8L16 17.414 18.586 20l-2.588 2.588 1.414 1.414L20 21.414 22.586 24 24 22.586 21.414 20l2.5-2.5-1.414-1.414-2.5 2.5L17.414 16Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "interface_actions_linkBreak_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgInterfaceActionsLinkBreak;